export default function Error({ error }) {
    console.log(error);
    return <p>An Error Occurred</p>;
}